export const UNDEFINED_ERROR_MESSAGE = `Неизвестная ошибка. Попробуйте позже
   или обратитесь в поддержку: ${process.env.VUE_APP_SUPPORT_EMAIL}`;

export const DEFAULT_NORTH_CHART_DEGREE = 62;
